import React from 'react'

import styles from './styles.module.scss'

export default function SettingsSeparator() {
  return <hr className={styles.settingsSeparator} />
}

export function SettingsEndSeparator() {
  return <hr className={styles.settingsEndSeparator} />
}
